/** One-time welcome credits modal after first profile create → /my-discovery */
export const PROFILE_WELCOME_CREDITS_KEY = "gt:showProfileWelcomeCredits";

/**
 * When set with PROFILE_WELCOME_CREDITS_KEY, post-create onboarding runs
 * verification → 15Q and skips the welcome-credits modal (generated-profile Save and finish).
 */
export const PROFILE_ONBOARDING_SKIP_CREDITS_KEY = "gt:profileOnboardingSkipCredits";

/** Session flag: registry verification modal already auto-opened for this company. */
export function verificationAutoOpenedSessionKey(companyId: string) {
  return `gt:verification-auto-opened:${companyId}`;
}